import { render, staticRenderFns } from "./Iconbar.vue?vue&type=template&id=47c58448&scoped=true&"
import script from "./Iconbar.vue?vue&type=script&lang=ts&"
export * from "./Iconbar.vue?vue&type=script&lang=ts&"
import style0 from "./Iconbar.vue?vue&type=style&index=0&id=47c58448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c58448",
  null
  
)

export default component.exports